<template>
    <div class="overflow-x-auto">

    </div>
  </template>
  
  <script>
  export default {
    name: 'UnauthorizedComponent',

  }
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>
  